<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-vr-cardboard', fontSet: 'fad'}"
	[headerText]="T.CREATE_NON_SIMSTATION_ROOM_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<form [formGroup]="createNonSimstationRoomForm" class="createNonSimstationRoomForm">
			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.SIM_ROOM_PLANNER_ROOM_NAME | translate }}</mat-label>
				<input formControlName="roomName" matInput placeholder="Room Name" type="text" />
				@if (createNonSimstationRoomForm.controls.roomName.hasError("required")) {
					<mat-error>
						{{ T.CREATE_NON_SIMSTATION_ROOM_DIALOG_ERROR_MESSAGE_ROOM_REQUIRED | translate }}
					</mat-error>
				}
			</mat-form-field>

			<sim-room-group-chip-input
				[canSelectMultipleRoomGroups]="false"
				[roomGroupFc]="createNonSimstationRoomForm.controls.roomGroup"
				label="Room Group"
				placeholder="Room Group"
			>
				<mat-icon fontIcon="fa-bookmark" fontSet="fad" inline labelSuffix />
			</sim-room-group-chip-input>
		</form>
	</ng-container>

	<ng-container actions>
		<button (click)="cancel()" [disabled]="loading" color="warn" mat-raised-button style="margin-right: 15px">
			{{ T.CREATE_NON_SIMSTATION_ROOM_DIALOG_CANCEL_BUTTON | translate }}
		</button>

		<button
			(click)="createNonSimstationRoom()"
			[disabled]="createNonSimstationRoomForm.invalid || loading"
			color="accent"
			mat-raised-button
		>
			{{ T.CREATE_NON_SIMSTATION_ROOM_DIALOG_BUTTON | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
